import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);


const singleBanner = () => {
  const bannerAnimation = gsap.timeline({
    paused: false,
  });

  const newsPageAnimation = gsap.timeline({
    paused: false,
  });


  if ( $('body').hasClass('single') ) {
    bannerAnimation.fromTo(
      ".banner__image",
      {
        scale: 2,
        rotate: 16,
        xPercent: -100,
        yPercent: 0,
        autoAlpha: 0,
      },
      {
        scale: 1,
        rotate: -4,
        autoAlpha: 1,
        xPercent: 0,
        yPercent: 0,
        duration: 1.2,
        ease: "power2.inOut",
      }
    )

    bannerAnimation.fromTo(
      ".banner .news-sidebar",
      {
        opacity: 0,
        y: 100,
        autoAlpha: 0,
      },
      {
        opacity: 1,
        y: 0,
        autoAlpha: 1,
        duration: 1.2,
        ease: "power2.inOut",
      },
      ">-0.6"
    );
  }



  if ( $('body').hasClass('page-template-tpl-contact') ) {
    bannerAnimation.fromTo(
      ".banner__image",
      {
        scale: 2,
        rotate: 16,
        xPercent: -100,
        yPercent: 0,
        autoAlpha: 0,
      },
      {
        scale: 1,
        rotate: -4,
        autoAlpha: 1,
        xPercent: 0,
        yPercent: 0,
        duration: 1.2,
        ease: "power2.inOut",
      }
    )

    bannerAnimation.fromTo(
      ".contact-title h1",
      {
        opacity: 0,
        y: -100,
        autoAlpha: 0,
      },
      {
        opacity: 1,
        autoAlpha: 1,
        y: 0,
        duration: 1.2,
        ease: "power2.inOut",
      },
      '>-0.6'
    )
    bannerAnimation.fromTo(
      ".single-main",
      {
        opacity: 0,
        y: 100,
        autoAlpha: 0,
      },
      {
        opacity: 1,
        autoAlpha: 1,
        y: 0,
        duration: 1.2,
        ease: "power2.inOut",
      },
      '>-0.9'
    )
  }







  newsPageAnimation.fromTo(
    ".banner--news .featured-post-item__image",
    {
      scale: 2,
      rotate: 16,
      xPercent: -100,
      yPercent: 0,
      autoAlpha: 0,
    },
    {
      scale: 1,
      rotate: -3,
      autoAlpha: 1,
      xPercent: 0,
      yPercent: 0,
      duration: 1.2,
      ease: "power2.inOut",
    }
  )
  newsPageAnimation.fromTo(
    ".banner--news h1",
    {
      opacity: 0,
      y: -100,
      autoAlpha: 0,
    },
    {
      opacity: 1,
      autoAlpha: 1,
      y: 0,
      duration: 1.2,
      ease: "power2.inOut",
    },
    '>-0.6'
  ) 

  newsPageAnimation.fromTo(
    ".featured-post-item__content",
    {
      opacity: 0,
      y: 100,
      autoAlpha: 0,
    },
    {
      opacity: 1,
      autoAlpha: 1,
      y: 0,
      duration: 1.2,
      ease: "power2.inOut",
    },
    '>-0.9'
  )
  

};

  




export default singleBanner;
